export const BAD_REQUEST_STATUS = 400;
export const PERMISSION_DENIED_STATUS = 403;
export const NOT_FOUND_STATUS = 404;
export const SERVER_ERROR_STATUS = 500;
